import getBaseUrl from './getBaseUrl';
import axios from '../axiosConfig';

/* This file was created to allow just the some functions to be available in
 * the myaccount-utils-static library. This was done to avoid refactoring all of
 * MyAccountApi.js (imports, dependencies, unit tests) in myact-react-static. If more
 * functionality is needed in myaccount-utils-static, then we may want to consider just
 * merging all of the MyAccountApi functionality into myaccount-utils-static.
 */

const options = { credentials: 'include' };

const getUrl = (path) => `${getBaseUrl()}billing${path[0] !== '/' ? '/' : ''}${path}`;

const BillingSvcLite = {
  setSMSMinimumUsage: ({ newFloor, updateBy }) => {
    return axios.put(getUrl(`/usage/minimum?usageType=SMS&newFloor=${newFloor}&updateBy=${updateBy}`), {}, options);
  },
  getPromoValidation: ({ payload }) => axios.post(getUrl('/promotions/validation'), payload, options),
  getRecurringUsage: () => {
    return axios.get(getUrl('/usage/type/SMS'), options);
  },
  getBillingAccount: () => {
    return axios.get(getUrl('/account'), options);
  },
  getBaasServiceIds: (planId) => axios.get(getUrl(`/${planId}/inclusion/baasserviceids`), {}),
  getAccount: () => axios.get(getUrl('/account'), options),
};

export default BillingSvcLite;
